import { mergeAnswers } from "../../../../questionnaire/utils/mergeAnswers";
import type {
  AddressSyncConfig,
  QuestionnaireState,
  UpdateAnswerPayload,
} from "../../../types";
import type { QuestionProps } from "../../../../../components/Questionnaire/Section/Question/types";
import { applyGroupAnswerAndVisibility } from "./applyGroupAnswerAndVisibility";

export const handleUpdateAnswerAction = (
  state: QuestionnaireState,
  payload: UpdateAnswerPayload,
): QuestionnaireState => {
  const { answers, changedQuestions, isEditing, answerTimestamps = {} } = state;
  // If the answer hasn't changed, return the current state
  if (payload.value === answers[payload.name]) return state;

  const addressSyncConfig = state.config?.addressSync as
    | AddressSyncConfig
    | undefined;
  const mergedAnswers = mergeAnswers(answers, payload, addressSyncConfig);
  const updatedChangedQuestions = [...(changedQuestions ?? []), payload.name];

  // Record timestamp for this answer update
  const updatedTimestamps = {
    ...answerTimestamps,
    [payload.name]: Date.now(),
  };

  const updatedState = {
    ...state,
    answers: mergedAnswers,
    answerTimestamps: updatedTimestamps,
    changedQuestions: isEditing ? updatedChangedQuestions : changedQuestions,
  };

  // Build a map of the current section's server-provided visibility for each question
  const currentSection = state.sections[state.currentSectionIndex];
  const serverVisibleState = Object.fromEntries(
    ((currentSection?.questions as QuestionProps[]) ?? []).map(
      ({ name, visible }) => [name, Boolean(visible)],
    ),
  ) as Record<string, boolean>;

  const { answers: groupAnswers, visibility: groupVisibility } =
    applyGroupAnswerAndVisibility(updatedState, payload, serverVisibleState);

  return {
    ...updatedState,
    answers: groupAnswers,
    visibility: groupVisibility,
  };
};
